<div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-[calc(100vh)]">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full">
    <div class="flex flex-row pt-6 px-4 pb-4 items-center" *ngIf="!isKiosk || isKiosk !== isMonter">
      <div class="mr-3">
        <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl" (onClick)="back()"></app-circle-button>
      </div>
      <div class="ml-2 text-3xl break-words w-[calc(100%-3rem)] text-theme-text">{{getString("Kvitto")}}</div>
    </div>

    <ng-container *ngIf="vm$ | async as vm">
      <div *ngIf="vm.loading">
        <app-loading-spinner size="lg"></app-loading-spinner>
      </div>

      <div *ngIf="!vm.loading && vm.receiptDetails;" class="pb-16">

        <div class="p-4 bg-theme text-theme-text rounded text-sm" *ngIf="vm.receiptDetails.post_actions">
          <!-- Pesentkort -->
          <div class="text-lg font-semibold px-4">{{ getString("Presentkort") }}</div>
          <div class="env-panel px-4 pt-4 bg-primary rounded" *ngFor="let pa of vm.receiptDetails.post_actions">
              <app-page-button text="{{getGiftcardName(pa)}}" icon="fa-regular fa-gift-card" (onClick)="openGiftcard(pa)"></app-page-button>
          </div>
        </div>

        <!-- Ticket vouchers -->
        <div class="p-4 mx-8 bg-theme text-theme-text rounded" *ngIf="(vm.receiptDetails.ticket_vouchers?.length ?? 0) > 0">
          <!-- En biljett -->
          <div class="mb-4" *ngIf="(vm.receiptDetails.ticket_vouchers?.length ?? 0) == 1">
            <div class="font-bold mb-2">{{ getString("Här nedan är din biljett!" )}}</div>
            <p>{{ getString("Du kan använda den direkt från telefonen, eller maila den för utskrift.") }}</p>
          </div>

          <!-- Flera biljetter -->
          <div class="text-sm mb-4" *ngIf="(vm.receiptDetails.ticket_vouchers?.length ?? 0) > 1">
            <div class="font-bold mb-2">{{ getString("Här nedan är dina biljetter!") }}</div>
            <p>{{ getString("Du kan använda den direkt från telefonen, eller maila den för utskrift.") }}</p>
          </div>

          <!-- Maila alla biljetter -->
          <div class="env-panel p-4 pt-4 bg-primary rounded" *ngIf="(vm.receiptDetails.ticket_vouchers?.length ?? 0) > 1">
            <app-page-button text="Maila alla biljetter ({{vm.receiptDetails.ticket_vouchers.length}}st)" icon="fa-ticket" (onClick)="sendAllTickets(vm.receiptDetails)"></app-page-button>
          </div>
        </div>

        <div class="mx-8 text-sm mb-4 text-theme-text border rounded-lg p-4" *ngFor="let ticket of vm.receiptDetails?.ticket_vouchers">
          <div class="flex flex-col gap-1">
            <div class="mb-4">
              <img [src]="ticket.ticket.logo_link">
            </div>
            <div *ngIf="ticket.ticket.name">
              {{ticket.ticket.name}}
            </div>
            <div *ngIf="ticket.ticket.date">
              {{ticket.ticket.date}}
            </div>
            <div *ngIf="ticket.ticket.place">
              Plats: {{ticket.ticket.place}}
            </div>
            <div *ngIf="ticket.price_cent">
              Pris: {{ moneyUtils.formatCent(ticket.price_cent) }}
            </div>
            <div *ngIf="ticket.ticket.desc">
              {{ticket.ticket.desc}}
            </div>
            <div  class="mx-auto max-w-xs text-center">
              <div class="my-4">
                *{{ticket.id}}*
              </div>
              <div class="mx-4 my-4">
                <img class="mx-auto" [src]="ticket.qr_url">
              </div>
            </div>
            <div>
              <div class="flex justify-between items-center pt-4">
                <app-link-button text="Maila biljett" icon="fa-envelope" (onClick)="sendTicket(ticket.id)"></app-link-button>
                <a *ngIf="ticket.ticket.more_text"
                   href="{{ticket.ticket.more_link}}"
                   target="_blank"
                   class="text-theme-text underline hover:text-primary-dark transition">
                  {{ticket.ticket.more_text}}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Vouchers -->
        <div class="mx-8 mt-4 p-4 rounded-lg border text-theme-text" *ngIf="!useModernVouchers && vm.receiptDetails.mvoucher" (click)="showTicket = !showTicket">
          <div class="text-lg font-semibold flex items-center">Biljett<i class="ml-auto far" [ngClass]="showTicket ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"></i></div>
          <div *ngIf="showTicket" class="pt-4">
            <div class="mt-4" *ngFor="let o of vm.receiptDetails.mvoucher">
              <app-dragger [voucher]="o" [venueId]="+venueId!" [type]="'feed'"></app-dragger>
            </div>
            <div class="mt-4 px-2 text-sm font-light italic text-theme-text">
              <p class="text-justify">{{getString(translate.STRING_ACTIVATE1)}}</p>
              <p class="mt-3">{{getString(translate.STRING_ACTIVATE2)}}</p>
            </div>
          </div>
        </div>

        <!-- Voucher bump -->
        <div class="mx-8 mt-4 border py-4 px-4 bg-theme rounded-lg text-theme-text" *ngIf="!useModernVouchers && vm.receiptDetails.voucher_bump" (click)="showBump = !showBump">
          <div class="text-lg font-semibold flex items-center">Pappersvoucher utskrift <i class="ml-auto far" [ngClass]="showBump ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"></i></div>
          <div *ngIf="showBump">
            <!-- Loading spinner -->
            <app-loading-spinner size="sm" *ngIf="bumpState.sending"></app-loading-spinner>

            <!-- Buttons for stations -->
            <div *ngIf="bumpState.bump != 's'">
              <div class="env-panel p-4 bg-primary rounded" *ngFor="let o of vm.receiptDetails.voucher_bump.stations">
                <app-page-button text="{{o.name}}" icon="fa-print" (onClick)="printVoucher(vm.receiptDetails.voucher_bump.key, o)"></app-page-button>
            </div>
              <!-- Information panel -->
              <div class="text-theme-text3">
                <b class="text-red-600 font-bold">OBS! Stå vid utskriftsstationen.</b>
                <p>Tryck på stationens namn ovan så skrivs din voucher ut.</p>
              </div>
            </div>

            <!-- Confirmation message -->
            <div *ngIf="bumpState.bump == 's'" class="text-green-600">
              Din voucher skrivs strax ut på <b>🖥️ {{bumpState.bump_station}}.</b> 😀
            </div>
          </div>
        </div>

        <!-- Voucher QR-code for print -->
        <div class="mx-8 mt-4 p-4 border rounded-lg text-theme-text" *ngIf="!useModernVouchers && vm.receiptDetails.voucher" (click)="showQR = !showQR">
          <div class="text-lg font-semibold flex items-center">Pappersvoucher QR-kod<i class="ml-auto far" [ngClass]="showQR ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"></i></div>
          <div *ngIf="showQR" class="mt-4">
            <!-- QR-kod bild -->
            <div class="mb-4">
              <img [src]="vm.receiptDetails.voucher" class="w-full rounded>" alt="QR-kod">
            </div>
            <!-- Informationspanel -->
            <div class="text-sm">
              {{ getString("Visa QR-koden för en skanningsstation inne på restaurangen för att få en voucher.") }}
            </div>
          </div>
        </div>

        <div class="mx-auto mt-4 max-w-80 text-theme-text">
          <div class="shadow-xl">
            <app-dossier-viewer *ngIf="vm.receiptDetails.dossier"
                                [printInstructions]="vm.receiptDetails.dossier.instructions">
            </app-dossier-viewer>
          </div>

          <div class="mt-10">
            <app-page-button text="{{getString(vm.receiptDetails.electronic_original ? 'Maila kvitto' : 'Maila kvittokopia')}}" icon="fa-paper-plane" (onClick)="sendReceipt(vm.receiptDetails)"></app-page-button>
          </div>
        </div>

<!--        <div class="env-panel p-4 pt-4 bg-primary rounded">-->
<!--           <div class="font-semibold pt-4" >{{getString("Miljövänligt kvitto")}}</div>-->
<!--          <div class="text-gray-600">{{getString("Elektroniska kvitton är ett bra miljöval.")}} 🌱 ☀️</div>-->
<!--        </div>-->
      </div>

      <div *ngIf="!vm.loading && vm.error">
        {{getString("Något gick fel!")}}
        {{vm.error}}
      </div>
    </ng-container>

  </div>
</div>
